import React from 'react'
import last from 'lodash/last'

export default class DocumentClassNames extends React.Component {
  constructor () {
    super()
    this.state = {
      classNames: []
    }
  }

  componentDidMount () {
    this.handlePathChange(this.props.path)
  }

  componentWillReceiveProps ({ path }) {
    this.handlePathChange(path)
  }

  handlePathChange (path) {
    this.removeClassNames(this.state.classNames)
    this.applyClassNames(
      this.generateClassNamesFromPath(path)
    )
  }

  removeClassNames (classNames) {
    classNames.forEach(className => {
      document.documentElement.classList.remove(className)
    })
  }

  applyClassNames (classNames) {
    classNames.forEach(className => {
      document.documentElement.classList.add(className)
    })
    this.setState({ classNames })
  }

  generateClassNamesFromPath (path) {
    let pathArray = path.substring(1).split('/')
      .filter(pathString => pathString !== '')

    if (pathArray.length > 0) {
      pathArray.push(`${last(pathArray)}-index`)
      return pathArray
    } else return ['home']
  }

  render () {
    return null
  }
}



// WEBPACK FOOTER //
// ./components/utils/DocumentClassNames/index.js